import React, { Component } from 'react';
import Truncate from 'react-truncate-html';
import PropTypes from 'prop-types';

// styles
import '../styles.scss';

class LxCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTruncated: true,
    };
  }
  toggle = () => {
    this.setState(prevState => ({
      isTruncated: !prevState.isTruncated,
    }));
  }
  dangerouslySetInnerHTML;

  render() {
    const { isTruncated } = this.state;
    const { item } = this.props;
    const { title, lexiconElementDefinition } = item;
    const lexiconElement = lexiconElementDefinition.replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/\n/g, '');
    const len = lexiconElement.length;
    let result;
    const lexiconContent = () => {
      if (len <= 300) {
        result = <div dangerouslySetInnerHTML={{
          __html: lexiconElementDefinition,
        }}
        />;
      }
      if (isTruncated && len > 300) {
        result = <Truncate
          lines={10}
          dangerouslySetInnerHTML={{
              __html: lexiconElementDefinition,
            }}
        />;
      }
      if (!isTruncated) {
        result = <div dangerouslySetInnerHTML={{
          __html: lexiconElementDefinition,
        }}
        />;
      }
      return result;
    };
    return (
      <li className="lexiqueItem">
        <article className="lexiqueItem__content">
          <div className={`${len <= 300 ? 'info' : ' info info--less '}`}>
            <h1 className="info--title">{title}</h1>
            <div className="info--desc">
              {lexiconContent()}
            </div>
          </div>
          {len > 300 &&
          <div className="info--actions">
            <button
              className={`readmore ${isTruncated ? 'readmore--plus' : 'readmore--minus'}`}
              onClick={this.toggle}
            />
          </div>}
        </article>
      </li>
    );
  }
}
LxCard.propTypes = {
  item: PropTypes.object.isRequired,
};

export default LxCard;



// WEBPACK FOOTER //
// ./src/app/components/pages/lexique/lexiqueResults/parts/LxCard.js